import { render, staticRenderFns } from "./ExpenseDetailReport.vue?vue&type=template&id=54b49d2e&scoped=true"
import script from "./ExpenseDetailReport.vue?vue&type=script&lang=js"
export * from "./ExpenseDetailReport.vue?vue&type=script&lang=js"
import style0 from "./ExpenseDetailReport.vue?vue&type=style&index=0&id=54b49d2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b49d2e",
  null
  
)

export default component.exports